<header>
    <app-header></app-header>
</header>
<main>
    <div class="bg-primary" style="height: 50px;"></div>
    <router-outlet></router-outlet>
</main>
<footer>
    <app-footer></app-footer>
</footer>